export default "__VITE_ASSET__BJnHQAb___"